// extracted by mini-css-extract-plugin
export default {"accordionContainer":"AccordionTypography_accordionContainer__RkHtf","fieldsContainer":"AccordionTypography_fieldsContainer__+3DtG"};